



import * as monaco from 'monaco-editor'
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator"
import {editor} from "monaco-editor"
import IStandaloneCodeEditor = editor.IStandaloneCodeEditor

@Component
export default class JSONEditor extends Vue {

    @Prop({required: true})
    value!: any

    editor: IStandaloneCodeEditor | null = null

    @Watch('value')
    onValueChanged() {
        if (this.editor && this.value) {
            this.editor.setValue(JSON.stringify(this.value, null, 4))
            this.$nextTick(() => {
                this.editor?.layout()
            })
        }
    }

    @Emit('input')
    valueModified() {
        return this.editor?.getValue()
    }

    onResize() {
        if (this.editor) {
            this.editor.layout()
        }
    }

    mounted() {
        this.$nextTick(() => {
            this.editor = monaco.editor.create(this.$refs['jsonEditor'] as any, {
                language: "json",
                theme: "vs"
            })
            this.onValueChanged()

            window.addEventListener('resize', this.onResize)

            this.editor.onDidChangeModelContent(() => this.valueModified())
        })
    }

    beforeDestroy() {
        this.editor?.dispose()
    }
}
